/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_Unknown_PersonInputs */

const cs_settings_teams_unknown_person = /** @type {(inputs: Settings_Teams_Unknown_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neznámá osoba`)
};

const en_settings_teams_unknown_person = /** @type {(inputs: Settings_Teams_Unknown_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown person`)
};

/**
* | output |
* | --- |
* | "Unknown person" |
*
* @param {Settings_Teams_Unknown_PersonInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_unknown_person = /** @type {((inputs?: Settings_Teams_Unknown_PersonInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_Unknown_PersonInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_unknown_person(inputs)
	return cs_settings_teams_unknown_person(inputs)
});